import { Link } from 'react-router-dom'

import { MarketPageHeader } from '../components/MarketPageHeader'

export const IikoIntegrationGuideScreen = () => (
  <section className="market-page market-page--wide">
    <MarketPageHeader
      title="Как подключить iiko к Провизиум"
      description="Настройте источник остатков, чтобы собирать закупку по фактическому расходу и вашим прайсам."
    />

    <div className="market-settings-columns">
      <article className="market-settings-column">
        <header className="market-settings-column__head">
          <h2 className="market-settings-column__title">Что поддерживается</h2>
        </header>
        <div className="market-settings-column__body">
          <p className="echat-muted">
            Сейчас Провизиум подключается к <strong>iiko Server</strong>. iikoCloud и другие ERP-системы пока не
            поддерживаются.
          </p>
          <p className="echat-muted">
            Интеграция забирает остатки кухни и бара, считает расход и предлагает позиции из «Моих прайсов» с
            учётом срока поставки.
          </p>
        </div>
      </article>

      <article className="market-settings-column">
        <header className="market-settings-column__head">
          <h2 className="market-settings-column__title">Где взять данные для подключения</h2>
        </header>
        <div className="market-settings-column__body">
          <ol className="market-muted">
            <li>Обратитесь к администратору iiko в заведении — обычно это управляющий, специалист по учёту или ИТ.</li>
            <li>
              Если такого сотрудника нет, напишите партнёру, который внедрял iiko и обслуживает ваш iiko Server.
            </li>
            <li>
              Попросите создать отдельную техническую учётную запись для «Провизиум» с правами просмотра Resto API
              и отчётов по складам.
            </li>
            <li>Попросите публичный HTTPS-адрес iiko Server, логин и пароль этой учётной записи.</li>
          </ol>
          <p className="echat-muted">
            Не используйте личную или административную учётную запись сотрудника. Пароль не пересылайте в чат или
            по почте: администратор может ввести его непосредственно в мастере подключения.
          </p>
        </div>
      </article>

      <article className="market-settings-column">
        <header className="market-settings-column__head">
          <h2 className="market-settings-column__title">Что подготовить</h2>
        </header>
        <div className="market-settings-column__body">
          <ol className="market-muted">
            <li>Публичный HTTPS-адрес iiko Server.</li>
            <li>Логин и пароль пользователя iiko с доступом к API и отчётам по складам.</li>
            <li>Хотя бы одного поставщика и его прайс в разделе «Мои прайсы».</li>
          </ol>
          <p className="echat-muted">
            Пароль вводится только в мастере, сохраняется защищённо и не показывается после сохранения. Не
            отправляйте его в чат или по почте.
          </p>
        </div>
      </article>

      <article className="market-settings-column">
        <header className="market-settings-column__head">
          <h2 className="market-settings-column__title">Как подключить</h2>
        </header>
        <div className="market-settings-column__body">
          <ol className="market-muted">
            <li>Откройте настройки интеграций и укажите адрес сервера, логин и пароль iiko.</li>
            <li>Запустите первую синхронизацию и назначьте каждому складу роль: кухня, бар или не учитывать.</li>
            <li>Проверьте, что в «Моих прайсах» есть сопоставимые товары и срок поставки.</li>
            <li>Вернитесь в «Заказ по остаткам» и выберите поставщика для расчёта.</li>
          </ol>
          <p className="echat-muted">
            После первой синхронизации может появиться статус «мало данных»: рекомендации становятся точнее,
            когда накопится минимум семь дней расхода.
          </p>
          <div className="market-actions-row">
            <Link className="echat-btn echat-btn--primary" to="/settings/integrations">
              Открыть мастер подключения
            </Link>
          </div>
        </div>
      </article>
    </div>
  </section>
)
